import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Lock, Mail, ArrowLeft } from "lucide-react";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.pexels.com/photos/577195/pexels-photo-577195.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Analytics" className="w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-gradient-to-br from-[#2563EB]/90 to-[#0F172A]/85"/>
        <div className="absolute inset-0 flex flex-col justify-between p-12 text-white">
          <div>
            <div className="flex items-center gap-2 mb-8">
              <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center font-bold">Q</div>
              <div className="font-bold text-lg" style={{ fontFamily: 'Poppins' }}>Quick Wash</div>
            </div>
            <h2 className="text-4xl font-bold leading-tight max-w-md" style={{ fontFamily: 'Poppins' }}>Manage your entire laundry business in one place.</h2>
            <p className="mt-4 text-blue-100 max-w-md">Bills · Customers · Rates · Reports · WhatsApp — all built for speed.</p>
          </div>
          <div className="text-xs text-blue-200">© Quick Wash · Rohtak, Haryana</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="text-sm text-slate-500 hover:text-slate-900 flex items-center gap-1 mb-8" data-testid="login-back"><ArrowLeft size={14}/>Back to home</Link>
          <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Poppins' }}>Sign in</h1>
          <p className="text-slate-500 mb-8">Admin & Staff access only. Enter your credentials to continue.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="qw-label">Email</label>
              <div className="relative"><Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" placeholder="you@quickwash.in" className="qw-input pl-10" data-testid="login-email"/>
              </div>
            </div>
            <div>
              <label className="qw-label">Password</label>
              <div className="relative"><Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" placeholder="Enter your password" className="qw-input pl-10" data-testid="login-password"/>
              </div>
              <div className="text-right mt-2">
                <Link to="/forgot-password" className="text-sm text-blue-600 hover:underline" data-testid="login-forgot">Forgot password?</Link>
              </div>
            </div>
            <button disabled={loading} className="qw-btn-primary w-full mt-2" data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</button>
          </form>
          <div className="mt-8 text-xs text-slate-400 text-center">Access restricted to authorised Quick Wash staff.</div>
        </div>
      </div>
    </div>
  );
};

export default Login;
